import { motion } from "framer-motion";

const PIPS = { 1: [4], 2: [0, 8], 3: [0, 4, 8], 4: [0, 2, 6, 8], 5: [0, 2, 4, 6, 8], 6: [0, 2, 3, 5, 6, 8] };

export const Die = ({ v, rolling, testid }) => (
  <motion.div animate={rolling ? { rotate: [0, 90, 180, 270, 360], y: [0, -20, 0, -10, 0] } : { rotate: 0 }} transition={rolling ? { repeat: Infinity, duration: 0.5 } : {}}
    className="w-16 h-16 sm:w-20 sm:h-20 rounded-2xl bg-gradient-to-br from-white to-zinc-300 shadow-[0_10px_30px_rgba(0,0,0,0.6)] grid grid-cols-3 grid-rows-3 p-2.5 gap-1" data-testid={testid}>
    {[...Array(9).keys()].map((i) => <span key={i} className={`rounded-full ${!rolling && PIPS[v || 1].includes(i) ? "bg-[#7B001C]" : "bg-transparent"}`} />)}
  </motion.div>
);

export const Pick = ({ children, onClick, disabled, active, testid, className = "" }) => (
  <motion.button whileHover={disabled ? {} : { y: -6, scale: 1.04 }} whileTap={disabled ? {} : { scale: 0.95 }} onClick={onClick} disabled={disabled}
    className={`relative flex flex-col items-center justify-center rounded-2xl transition-colors ${active ? "ring-2 ring-[#FFD700]" : ""} ${className}`} data-testid={testid}>
    {children}
  </motion.button>
);

export const MultTag = ({ m, win }) => (
  <motion.span initial={{ scale: 0, y: 10 }} animate={{ scale: 1, y: 0 }} className={`font-display font-black text-sm sm:text-lg px-2 rounded ${win ? "text-emerald-300" : m > 0 ? "text-sky-300" : "text-zinc-500"}`}>x{m}</motion.span>
);

export const Stage = ({ children, bg, testid }) => (
  <div className="relative rounded-3xl overflow-hidden border border-white/10 min-h-[300px] sm:min-h-[400px] flex flex-col items-center justify-center p-4 sm:p-8 gap-4"
    style={{ background: bg || "radial-gradient(ellipse at center, #1f1308 0%, #0a0a0a 70%)" }} data-testid={testid}>{children}</div>
);
